(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fabrikone-audience-home"] && !Shopify.designMode) return;
  try {
    
  function initFabrikoneAudience(root) {
    if (root.dataset.fbaReady) return;
    root.dataset.fbaReady = 'true';
    const qa = selector => Array.from(root.querySelectorAll(selector));
    const format = value => new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency: root.dataset.currency || 'TRY' }).format(value / 100);
    let busy = false;
    const forms = qa('.fba-product__form');
    const kit = root.querySelector('[data-fba-kit]');
    const kitButton = root.querySelector('[data-fba-kit-submit]');
    function updateProduct(form) {
      const selected = form.querySelector('[data-fba-variant]')?.selectedOptions[0] || form.querySelector('[data-fba-single]');
      const button = form.querySelector('[data-fba-submit]');
      form.querySelector('[data-fba-price]').textContent = format(Number(selected.dataset.price));
      button.disabled = busy || selected.dataset.available !== 'true';
      button.textContent = selected.dataset.available === 'true' ? root.dataset.add : root.dataset.sold;
      if (selected.dataset.url) form.closest('[data-fba-product]').querySelectorAll('[data-fba-product-link]').forEach(link => link.href = selected.dataset.url);
      const picture = form.closest('[data-fba-product]').querySelector('.fba-product__image');
      if (picture && selected.dataset.image) {
        picture.srcset = selected.dataset.srcset;
        picture.src = selected.dataset.image;
      }
    }
    function selection() {
      let total = 0;
      let invalid = false;
      const items = new Map();
      qa('[data-fba-kit-row]').forEach(row => {
        const option = row.querySelector('select').selectedOptions[0];
        const count = Number(row.querySelector('[data-fba-quantity]').value);
        row.querySelector('[data-fba-row-price]').textContent = format(Number(option.dataset.price) * (Number.isFinite(count) ? count : 0));
        if (!row.querySelector('[data-fba-include]').checked) return;
        if (!Number.isInteger(count) || count < 1 || count > 100 || option.dataset.available !== 'true') invalid = true;
        const previous = items.get(option.value);
        const item = { id: Number(option.value), quantity: (previous?.quantity || 0) + count, limit: option.dataset.limit === '' ? null : Number(option.dataset.limit) };
        if (item.limit !== null && item.quantity > item.limit) invalid = true;
        items.set(option.value, item);
        total += Number(option.dataset.price) * count;
      });
      return { total, invalid, items: Array.from(items.values()).map(({ id, quantity }) => ({ id, quantity })) };
    }
    function updateKit() {
      if (!kit) return;
      kit.querySelectorAll('[data-fba-kit-row]').forEach(row => {
        const included = row.querySelector('[data-fba-include]').checked;
        row.querySelectorAll('select,[data-fba-quantity]').forEach(field => field.disabled = busy || !included);
      });
      const data = selection();
      kit.querySelector('[data-fba-total]').textContent = format(Number.isFinite(data.total) ? data.total : 0);
      kitButton.disabled = busy || data.invalid || data.items.length === 0;
    }
    function setBusy(value) {
      busy = value;
      forms.forEach(form => {
        form.setAttribute('aria-busy', String(value));
        const select = form.querySelector('select');
        if (select) select.disabled = value;
        updateProduct(form);
      });
      if (kit) {
        kit.setAttribute('aria-busy', String(value));
        kit.querySelectorAll('input,select').forEach(input => input.disabled = value);
      }
      updateKit();
    }
    async function addItems(items, feedback) {
      if (busy) return;
      setBusy(true);
      feedback.dataset.error = 'false';
      feedback.textContent = root.dataset.busy;
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : '');
        feedback.replaceChildren(document.createTextNode(root.dataset.added + ' '));
        const link = document.createElement('a');
        link.href = root.dataset.cartUrl;
        link.textContent = root.dataset.cartLabel + ' →';
        feedback.append(link);
        try {
          const cartResponse = await fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-fabrikone-cart-count]').forEach(counter => { counter.textContent = cart.item_count; counter.hidden = cart.item_count === 0; });
          }
        } catch (_) {}
      } catch (error) {
        feedback.dataset.error = 'true';
        feedback.textContent = root.dataset.error + (error.message ? ' ' + error.message : '');
      } finally {
        setBusy(false);
      }
    }
    forms.forEach(form => {
      updateProduct(form);
      form.querySelector('select')?.addEventListener('change', () => {
        updateProduct(form);
        form.querySelector('[data-fba-feedback]').textContent = '';
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (busy || !form.reportValidity() || form.querySelector('[data-fba-submit]').disabled) return;
        const values = new FormData(form);
        addItems([{ id: Number(values.get('id')), quantity: 1 }], form.querySelector('[data-fba-feedback]'));
      });
    });
    if (kit) {
      kit.addEventListener('input', updateKit);
      kit.addEventListener('change', () => { kit.querySelector('[data-fba-feedback]').textContent = ''; updateKit(); });
      kit.addEventListener('submit', event => {
        event.preventDefault();
        if (busy || !kit.reportValidity()) return;
        const data = selection();
        if (data.invalid || !data.items.length) { kit.querySelector('[data-fba-feedback]').textContent = root.dataset.empty; return; }
        addItems(data.items, kit.querySelector('[data-fba-feedback]'));
      });
      updateKit();
    }
  }
  document.querySelectorAll('[data-fba-home]').forEach(initFabrikoneAudience);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fba-home]').forEach(initFabrikoneAudience));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrikone-global-footer"]) return;
  try {
    
(()=>{const mq=matchMedia('(max-width:749px)'),apply=()=>document.querySelectorAll('.fgf__fold').forEach(el=>{el.open=!mq.matches;el.querySelector('summary').tabIndex=mq.matches?0:-1;});apply();mq.addEventListener('change',apply);document.addEventListener('shopify:section:load',apply);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrikone-home"] && !Shopify.designMode) return;
  try {
    

function initFabrikoneHome(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const q=s=>root.querySelector(s),qa=s=>Array.from(root.querySelectorAll(s));
 const money=n=>new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{style:'currency',currency:root.dataset.currency||'TRY'}).format(n/100);
 let busy=false;
 async function addItems(items,feedback){
  if(busy)return;busy=true;feedback.textContent=root.dataset.busy;
  const controls=qa('button[type="submit"]');const states=controls.map(b=>b.disabled);controls.forEach(b=>b.disabled=true);
  try{const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
   const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||root.dataset.error);
   feedback.replaceChildren(document.createTextNode(root.dataset.added+' '));const link=document.createElement('a');link.href=root.dataset.cartUrl;link.textContent=q('.fh-actions a:last-child').getAttribute('aria-label')+' →';link.style.textDecoration='underline';feedback.append(link);
   try{const cartResponse=await fetch(root.dataset.cartUrl+'.js');if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-fabrikone-cart-count]').forEach(e=>{e.textContent=cart.item_count;e.hidden=cart.item_count===0;});document.dispatchEvent(new CustomEvent('cart:refresh'));}}catch(_){}
  }catch(error){feedback.textContent=root.dataset.error+' '+error.message;}
  finally{busy=false;controls.forEach((b,i)=>b.disabled=states[i]);updateKit();}
 }
 const tabs=qa('[data-home-tab]');
 function chooseTab(tab){tabs.forEach(b=>b.setAttribute('aria-selected',String(b===tab)));qa('[data-home-panel]').forEach(p=>p.hidden=p.dataset.homePanel!==tab.dataset.homeTab);}
 tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>chooseTab(tab));tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?tabs.length-1:(index+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;chooseTab(tabs[next]);tabs[next].focus();});});
 qa('.fh-product-form').forEach(form=>{
  const select=form.querySelector('select[name=id]'),button=form.querySelector('button[type=submit]');
  if(select)select.addEventListener('change',()=>{const opt=select.selectedOptions[0];form.querySelector('[data-product-price]').textContent=opt.dataset.money;button.disabled=opt.dataset.available!=='true';button.textContent=button.disabled?root.dataset.sold:root.dataset.add;form.querySelector('.fh-feedback').textContent='';});
  form.addEventListener('submit',e=>{e.preventDefault();if(!form.reportValidity())return;addItems([{id:Number(new FormData(form).get('id')),quantity:1}],form.querySelector('.fh-feedback'));});
 });
 const kit=q('[data-home-kit]'),kitButton=q('[data-kit-add]');
 function kitData(){let invalid=false,total=0;const map=new Map();qa('[data-kit-row]').forEach(row=>{const option=row.querySelector('select').selectedOptions[0],quantity=Number(row.querySelector('[data-kit-quantity]').value),included=row.querySelector('[data-kit-check]').checked;row.querySelector('[data-kit-price]').textContent=money(Number(option.dataset.price)*(Number.isFinite(quantity)?quantity:0));if(!included)return;if(!Number.isInteger(quantity)||quantity<1||quantity>1000||option.dataset.available!=='true')invalid=true;const previous=map.get(option.value);map.set(option.value,{id:Number(option.value),quantity:(previous?.quantity||0)+quantity,limit:option.dataset.limit===''?null:Number(option.dataset.limit)});total+=Number(option.dataset.price)*quantity;});for(const item of map.values())if(item.limit!==null&&item.quantity>item.limit)invalid=true;return{items:[...map.values()].map(({id,quantity})=>({id,quantity})),total,invalid};}
 function updateKit(){const d=kitData();q('[data-kit-total]').textContent=money(d.total);kitButton.disabled=busy||d.invalid||!d.items.length;}
 kit.addEventListener('input',updateKit);kit.addEventListener('change',()=>{q('.fh-kit .fh-feedback').textContent='';updateKit();});kit.addEventListener('submit',e=>{e.preventDefault();if(!kit.reportValidity())return;const d=kitData();if(d.invalid||!d.items.length){q('.fh-kit .fh-feedback').textContent=root.dataset.empty;return;}addItems(d.items,q('.fh-kit .fh-feedback'));});updateKit();
}
document.querySelectorAll('[data-home]').forEach(initFabrikoneHome);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-home]').forEach(initFabrikoneHome));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrikone-sky-workshop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const entries = new Map();

  const position = (scene, photo) => {
    if (!photo.complete || !photo.naturalWidth || !photo.naturalHeight) return;
    const width = scene.clientWidth;
    const height = scene.clientHeight;
    if (!width || !height) {
      scene.style.setProperty('--fsky-brand-visibility', 'hidden');
      return;
    }
    const scale = Math.max(width / photo.naturalWidth, height / photo.naturalHeight);
    const drawnWidth = photo.naturalWidth * scale;
    const drawnHeight = photo.naturalHeight * scale;
    const offsetX = (width - drawnWidth) / 2;
    const offsetY = (height - drawnHeight) / 2;
    scene.style.setProperty('--fsky-brand-left', `${offsetX + drawnWidth * 427 / 1086}px`);
    scene.style.setProperty('--fsky-brand-top', `${offsetY + drawnHeight * 904 / 1448}px`);
    scene.style.setProperty('--fsky-brand-width', `${drawnWidth * 194 / 1086}px`);
    scene.style.setProperty('--fsky-brand-visibility', 'visible');
  };

  const initialize = (root) => {
    root.querySelectorAll('[data-fsky-brand-scene]').forEach((scene) => {
      if (entries.has(scene)) return;
      const photo = scene.querySelector('.fsky-hero__photo');
      if (!photo) return;
      const update = () => position(scene, photo);
      const observer = window.ResizeObserver ? new ResizeObserver(update) : null;
      entries.set(scene, { photo, update, observer });
      photo.addEventListener('load', update);
      if (observer) observer.observe(scene);
      update();
    });
  };

  const dispose = (root) => {
    for (const [scene, entry] of entries) {
      if (!root.contains(scene)) continue;
      entry.photo.removeEventListener('load', entry.update);
      if (entry.observer) entry.observer.disconnect();
      entries.delete(scene);
    }
  };

  if (!window.ResizeObserver) {
    window.addEventListener('resize', () => {
      for (const entry of entries.values()) entry.update();
    }, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => dispose(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrikone-storefront-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fab-discovery')) customElements.define('fab-discovery',class extends HTMLElement {
    connectedCallback() {
      if (this.life) return;
      this.life=new AbortController();const signal=this.life.signal;
      this.money=new Intl.NumberFormat(document.documentElement.lang || 'tr',{style:'currency',currency:this.dataset.currency || 'TRY'});
      this.observers=[];this.railFrames=new Set();
      this.querySelectorAll('[data-fd-rail]').forEach(rail => {
        const track=rail.querySelector('[data-fd-track]'),prev=rail.querySelector('[data-fd-prev]'),next=rail.querySelector('[data-fd-next]');
        let frame=0,startX=0,startScroll=0,dragging=false,moved=false;
        const update=() => {this.railFrames.delete(frame);frame=0;const max=track.scrollWidth-track.clientWidth;prev.disabled=track.scrollLeft<3;next.disabled=track.scrollLeft>max-3 || max<3;};
        const schedule=() => {if (!frame) {frame=requestAnimationFrame(update);this.railFrames.add(frame);}};
        const scroll=dir => {const first=[...track.children].find(el=>el.getBoundingClientRect().width>0);if(!first)return;const gap=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:dir*(first.getBoundingClientRect().width+gap),behavior:'instant'});};
        prev.addEventListener('click',() => scroll(-1),{signal});next.addEventListener('click',() => scroll(1),{signal});
        track.addEventListener('scroll',schedule,{passive:true,signal});
        track.addEventListener('keydown',e => {if (e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();scroll(e.key==='ArrowRight'?1:-1);}},{signal});
        track.addEventListener('pointerdown',e => {if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('select,input,button,label'))return;startX=e.clientX;startScroll=track.scrollLeft;dragging=true;moved=false;},{signal});
        window.addEventListener('pointermove',e => {if(!dragging)return;const delta=e.clientX-startX;if(Math.abs(delta)>7){moved=true;track.style.scrollSnapType='none';track.style.userSelect='none';track.scrollLeft=startScroll-delta;e.preventDefault();}},{signal});
        const stop=() => {dragging=false;track.style.scrollSnapType='';track.style.userSelect='';};
        window.addEventListener('pointerup',stop,{signal});window.addEventListener('pointercancel',stop,{signal});window.addEventListener('blur',stop,{signal});
        track.addEventListener('dragstart',e=>e.preventDefault(),{signal});track.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation();moved=false;}},{capture:true,signal});
        const observer=new ResizeObserver(schedule);observer.observe(track);this.observers.push(observer);update();
      });
      this.querySelectorAll('[data-fd-product]').forEach(card=>this.updateProduct(card));
      this.addEventListener('change',e=>{const card=e.target.closest('[data-fd-product]');if(card)this.updateProduct(card);this.total();},{signal});
      this.addEventListener('input',e=>{if(e.target.name==='quantity')this.total();},{signal});
      this.addEventListener('submit',e=>{if(!e.target.matches('.fd-product__form'))return;e.preventDefault();e.stopPropagation();if(!e.target.reportValidity())return;const id=e.target.elements.id.value,quantity=Number(e.target.elements.quantity.value);this.addItems([{id,quantity}],e.target.querySelector('[data-fd-add]'),e.target.querySelector('[data-fd-status]'));},{signal});
      this.dialog=this.querySelector('dialog');this.dialogTitle=this.dialog.querySelector('.fd-dialog__top h2');this.defaultDialogTitle=this.dialogTitle.textContent;
      this.addEventListener('click',e=>{
        const collection=e.target.closest('[data-fd-collection]');
        if(collection){e.preventDefault();const template=this.querySelector('[data-fd-collection-template="'+CSS.escape(collection.dataset.fdCollection)+'"]');if(!template)return;this.returnFocus=collection;this.dialogTitle.textContent=collection.dataset.title;const body=this.querySelector('[data-fd-dialog-body]');body.replaceChildren(template.content.cloneNode(true));body.querySelectorAll('[data-fd-product]').forEach(card=>this.updateProduct(card));this.oldOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';return;}
        const trigger=e.target.closest('[data-fd-open]');
        if(trigger){this.dialogTitle.textContent=this.defaultDialogTitle;this.returnFocus=trigger;const key=trigger.dataset.fdOpen;const template=this.querySelector('[data-fd-template="'+CSS.escape(key)+'"]');if(!template)return;const body=this.querySelector('[data-fd-dialog-body]');body.replaceChildren(template.content.cloneNode(true));const source=this.querySelector('[data-fd-material="'+CSS.escape(key)+'"] [name="id"]'),target=body.querySelector('[name="id"]');if(source&&target)target.value=source.value;body.querySelectorAll('[data-fd-product]').forEach(card=>this.updateProduct(card));this.dialog.showModal();this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';}
        if(e.target.closest('[data-fd-close]'))this.dialog.close();
        if(e.target.closest('[data-fd-bundle]')){const rows=[...this.querySelectorAll('[data-fd-material]')].filter(row=>row.querySelector('[data-fd-check]').checked);if(!rows.every(row=>row.querySelector('form').reportValidity()))return;const items=rows.map(row=>({id:row.querySelector('[name="id"]').value,quantity:Number(row.querySelector('[name="quantity"]').value)}));this.addItems(items,this.querySelector('[data-fd-bundle]'),this.querySelector('[data-fd-bundle-status]'));}
      },{signal});
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();},{signal});
      this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.oldOverflow||'';this.returnFocus?.focus({preventScroll:true});},{signal});
      this.total();
    }
    variant(card){const field=card.querySelector('[name="id"]');return field.tagName==='SELECT'?field.selectedOptions[0]:field;}
    updateProduct(card){const variant=this.variant(card),quantity=card.querySelector('[name="quantity"]'),button=card.querySelector('[data-fd-add]');card.querySelector('[data-fd-price]').textContent=this.money.format(Number(variant.dataset.price)/100);const min=Number(variant.dataset.min||quantity.min||1),step=Number(variant.dataset.step||quantity.step||1);quantity.min=min;quantity.step=step;if(variant.dataset.max)quantity.max=variant.dataset.max;else quantity.removeAttribute('max');if(Number(quantity.value)<min||(Number(quantity.value)-min)%step)quantity.value=min;if(button){button.disabled=variant.dataset.available!=='true';button.textContent=button.disabled?this.dataset.soldOut:this.dataset.add;}const check=card.closest('[data-fd-material]')?.querySelector('[data-fd-check]');if(check){check.disabled=variant.dataset.available!=='true';if(check.disabled)check.checked=false;}}
    total(){let amount=0,count=0;this.querySelectorAll('[data-fd-material]').forEach(row=>{if(!row.querySelector('[data-fd-check]').checked)return;const card=row.querySelector('[data-fd-product]');amount+=Number(this.variant(card).dataset.price)*Number(card.querySelector('[name="quantity"]').value||0);count++;});this.querySelector('[data-fd-total]').textContent=this.money.format(amount/100);const button=this.querySelector('[data-fd-bundle]');if(!button.dataset.busy)button.disabled=count===0;}
    async addItems(items,button,status){if(!button||button.disabled||!items.length)return;const label=button.textContent;button.disabled=true;button.dataset.busy='true';button.textContent=this.dataset.working;status.textContent='';status.removeAttribute('data-error');try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.dataset.error);status.textContent=this.dataset.added;document.dispatchEvent(new CustomEvent('cart:updated'));}catch(error){status.textContent=error.message||this.dataset.error;status.setAttribute('data-error','');}finally{button.disabled=false;delete button.dataset.busy;button.textContent=label;this.total();}}
    disconnectedCallback(){this.life?.abort();this.life=null;this.observers?.forEach(o=>o.disconnect());this.railFrames?.forEach(id=>cancelAnimationFrame(id));if(this.dialog?.open){document.documentElement.style.overflow=this.oldOverflow||'';this.dialog.close();}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabrikone-studio"] && !Shopify.designMode) return;
  try {
    
// Only a Shopify-signed same-origin proxy can identify the customer. No secrets here.
class FabrikoneStudioCloud {
  constructor(request = (...args) => fetch(...args)) {
    this.request = request; this.mode = 'checking'; this.customerId = ''; this.projects = []; this.csrf = '';
  }
  async json(options = {}) {
    const response = await this.request('/apps/studyom/projects', {credentials:'same-origin', cache:'no-store', redirect:'error', ...options,
      headers:{Accept:'application/json', ...options.headers}, signal:AbortSignal.timeout(18000)});
    let data; try { data = await response.json(); } catch { throw new Error('INVALID_RESPONSE'); }
    if (!response.ok) { const error = new Error(data.error || 'CONNECTION_FAILED'); error.status = response.status; throw error; }
    return data;
  }
  async refresh() {
    if (this.refreshing) return this.refreshing;
    this.refreshing = (async () => {
      try {
        const data = await this.json();
        if (!/^[1-9]\d{0,19}$/.test(data.customerId || '') || typeof data.csrf !== 'string' || !Array.isArray(data.projects) || data.projects.length > 50 || JSON.stringify(data.projects).length > 60000) throw new Error('INVALID_RESPONSE');
        if (data.projects.some(p => !Number.isInteger(p.revision) || p.revision < 1)) throw new Error('INVALID_RESPONSE');
        this.customerId = data.customerId; this.csrf = data.csrf; this.projects = data.projects; this.mode = 'account';
      } catch (error) {
        this.csrf = ''; this.projects = [];
        if (error.status === 401 && error.message === 'LOGIN_REQUIRED') { this.customerId = ''; this.mode = 'guest'; }
        else { this.mode = 'error'; this.error = error.message; }
      }
      return this.mode;
    })();
    try { return await this.refreshing; } finally { this.refreshing = null; }
  }
  async save(project, baseRevision, owner) {
    if (this.mode !== 'account' || !owner || owner !== this.customerId || !this.csrf) throw new Error('ACCOUNT_CHANGED');
    const data = await this.json({method:'POST',headers:{'Content-Type':'application/json','X-Studyom-CSRF':this.csrf},body:JSON.stringify({action:'save',baseRevision,project})});
    if (data.saved?.id !== project.id || data.saved.revision !== baseRevision + 1) throw new Error('INVALID_RESPONSE');
    this.projects = [data.saved, ...this.projects.filter(p => p.id !== project.id)];
    return data.saved;
  }
  async remove(id, baseRevision, owner) {
    if (this.mode !== 'account' || owner !== this.customerId || !owner || !this.csrf) throw new Error('ACCOUNT_CHANGED');
    const data = await this.json({method:'POST',headers:{'Content-Type':'application/json','X-Studyom-CSRF':this.csrf},body:JSON.stringify({action:'delete',baseRevision,id})});
    if(data.deleted !== id) throw new Error('INVALID_RESPONSE');
    this.projects = this.projects.filter(p => p.id !== id);
  }
}
class FabrikoneStudio extends HTMLElement {
  static quantities(input) {
    const number = (key, min, max, fallback = 0) => {
      const value = input[key] === '' || input[key] == null ? fallback : Number(input[key]);
      if (!Number.isFinite(value) || value < min || value > max) throw new RangeError(key);
      return value;
    };
    const count = number('count', 1, 10000, 4);
    if (!Number.isInteger(count)) throw new RangeError('count');
    const fill = number('fill', 1, 10000, 200), height = number('height', 1, 100, 8);
    const rate = number('rate', 0, 12, 8), density = number('density', 0.1, 3, 1);
    const wax = count * fill, fragrance = input.fragrance ? wax * rate / 100 : 0;
    const dye = input.dye && input.family !== 'gel' ? wax / 100 : 0;
    const tone = number('tone', 0.02, 0.1, 0.05);
    const need = { wax, fragrance, dye, wick: count * (height + 2) / 100, container: count };
    const remaining = {};
    for (const [key, value] of Object.entries(need)) {
      const owned = number('owned_' + key, 0, 100000000);
      remaining[key] = input.owned?.[key] ? 0 : Math.max(0, value - owned);
    }
    return { count, fill, wax, fragrance, dye, wick: need.wick, cut: height + 2, rate, density,
      mixture: wax + fragrance, dyeTrial: dye ? wax * tone / 100 : 0, need, remaining,
      fragranceMl: remaining.fragrance / density, approximate: input.density === '' || input.density == null };
  }
  static packagePlan(variants, need, selectedId) {
    if (!Number.isFinite(need) || need <= 0) return null;
    const plans = variants.filter(v => v.available && v.size > 0 && (!selectedId || String(v.id) === String(selectedId))).map(v => {
      const min = Math.max(1, Number(v.min) || 1), step = Math.max(1, Number(v.step) || 1);
      const raw = Math.ceil((need - 1e-9) / v.size);
      const quantity = min + Math.ceil(Math.max(0, raw - min) / step) * step;
      const max = Math.min(v.max == null ? Infinity : v.max, v.stock == null ? Infinity : v.stock);
      if (quantity > max || !Number.isInteger(quantity) || quantity <= 0) return null;
      return { variant: v, quantity, supplied: quantity * v.size, left: Math.max(0, quantity * v.size - need), cost: quantity * v.price };
    }).filter(Boolean);
    plans.sort((a, b) => a.left - b.left || a.cost - b.cost || a.quantity - b.quantity);
    return plans[0] || null;
  }
  static size(product, variant, unit) {
    const text = ((variant.title === 'Default Title' ? product.title : variant.title) || '').toLocaleLowerCase('tr-TR').replace(/,/g, '.');
    const patterns = { g: /(\d+(?:\.\d+)?)\s*(kg|kilogram|gr|gram|g)\b/i, ml: /(\d+(?:\.\d+)?)\s*(ml|cc|l|litre)\b/i, cc: /(\d+(?:\.\d+)?)\s*(cc|ml)\b/i, m: /(\d+(?:\.\d+)?)\s*(metre|meter|cm|m)\b/i, adet: /(\d+)\s*(adet|ad|pcs)\b/i };
    if (unit === 'g' && product.variants.length === 1 && Number(product.meta?.net_g) > 0) return Number(product.meta.net_g);
    const match = text.match(patterns[unit]);
    if (!match) return unit === 'adet' && product.variants.length === 1 ? 1 : 0;
    return Number(match[1]) * ((unit === 'g' && ['kg','kilogram'].includes(match[2])) || (unit === 'ml' && ['l','litre'].includes(match[2])) ? 1000 : (unit === 'm' && match[2] === 'cm' ? 0.01 : 1));
  }
  connectedCallback() {
    if (this.life) return;
    this.life = new AbortController();
    this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
    this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
    this.form = this.querySelector('[data-plan-form]');
    this.dialog = this.querySelector('dialog');
    this.money = new Intl.NumberFormat(this.dataset.locale || 'tr-TR', { style: 'currency', currency: this.dataset.currency || 'TRY' });
    this.numbers = new Intl.NumberFormat(this.dataset.locale || 'tr-TR', { maximumFractionDigits: 3 });
    this.storageKey = 'fabrikone.studyom.projects.v1';
    this.cloud = new FabrikoneStudioCloud(); this.projectRevision = 0; this.projectOwner = '';
    this.level = 'beginner'; this.owned = {}; this.choices = {}; this.checks = []; this.toolOwned = {};
    this.products = this.catalog.flatMap(g => g.products);
    this.catalog.filter(g => g.kind === 'family').forEach(g => this.field('family').add(new Option(g.title, g.key)));
    this.field('family').value = 'leaf';
    for (const kind of ['fragrance','dye']) {
      const select = this.field(kind); select.add(new Option(this.t(kind === 'fragrance' ? 'unscented' : 'uncolored'), ''));
      this.group(kind).products.forEach(p => select.add(new Option(this.shortTitle(p.title), String(p.id))));
    }
    const signal = this.life.signal;
    this.form.addEventListener('submit', e => { e.preventDefault(); if (!this.form.reportValidity()) return; this.calculate(); this.focusSummary(); }, {signal});
    this.form.addEventListener('input', e => { if (e.target.name === 'name') this.dirty = true; else this.changed(e.target.name); }, {signal});
    this.form.addEventListener('change', e => this.changed(e.target.name), {signal});
    this.addEventListener('click', e => this.click(e), {signal});
    this.q('[data-cloud-login]').addEventListener('click', e=>{
      if(this.dirty&&!confirm(this.t('unsaved_confirm'))){e.preventDefault();return;}
      const url=new URL('/customer_authentication/login',location.origin);
      url.searchParams.set('return_to',location.pathname+location.search);
      e.currentTarget.href=url.href;
    },{signal});
    this.querySelector('[data-notes]').addEventListener('input', () => { this.dirty = true; }, {signal});
    this.querySelector('[data-import]').addEventListener('change', e => this.importFile(e.target), {signal});
    this.dialog.addEventListener('click', e => { if (e.target !== this.dialog) return; const r = this.dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top) this.dialog.close(); }, {signal});
    this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = this.oldOverflow || ''; this.returnFocus?.focus({preventScroll:true}); }, {signal});
    window.addEventListener('popstate', () => this.route(), {signal});
    window.addEventListener('storage', e => { if (e.key === this.storageKey && this.screen === 'saved') this.renderSaved(); }, {signal});
    document.addEventListener('visibilitychange', () => { if (!document.hidden && !this.saving) this.refreshAccount(); }, {signal});
    window.addEventListener('focus', () => { if (!this.saving) this.refreshAccount(); }, {signal});
    const params = new URLSearchParams(location.search);
    this.setLevel(['beginner','maker','workshop'].includes(params.get('level')) ? params.get('level') : 'beginner');
    this.changed('family'); this.dirty = false; this.route(); this.ready = true;
    this.refreshAccount();
  }
  t(key) { return this.copy[key] || key; }
  q(selector) { return this.querySelector(selector); }
  field(name) { return this.form.elements.namedItem(name); }
  fmt(value) { return this.numbers.format(value); }
  price(cents) { return this.money.format(cents / 100); }
  shortTitle(title) { return title.split(' - ')[0].replace(' Premium Mum Esansı', ' Mum Esansı'); }
  group(key) { return this.catalog.find(g => g.key === key) || {products: []}; }
  el(tag, text, className) { const e = document.createElement(tag); if (text != null) e.textContent = text; if (className) e.className = className; return e; }
  button(text, run, className = 'fst-secondary') { const b = this.el('button', text, className); b.type = 'button'; b.addEventListener('click', run, {signal:this.life.signal}); return b; }
  inputs() { const data = Object.fromEntries(new FormData(this.form)); data.family = this.field('family').value; data.owned = this.owned; return data; }
  setLevel(level) {
    this.level = level; this.dataset.level = level;
    this.querySelectorAll('[data-level]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.level === level)));
    this.q('[data-level-description]').textContent = this.t(level + '_desc');
    this.querySelectorAll('.fst-workshop').forEach(el => { if (el.tagName === 'DETAILS') el.open = level === 'workshop'; });
    if(level==='workshop')this.querySelectorAll('details.fst-advanced').forEach(el=>el.open=true);
  }
  route() { const view = new URLSearchParams(location.search).get('screen'); this.show(['saved','steps','notes'].includes(view) ? view : 'plan', false); }
  show(view, update = true) {
    this.screen = view;
    this.querySelectorAll('[data-screen]').forEach(s => s.hidden = s.dataset.screen !== view);
    this.querySelectorAll('.fst-sidebar [data-view]').forEach(b => { if (b.dataset.view === view) b.setAttribute('aria-current','page'); else b.removeAttribute('aria-current'); });
    if (view === 'saved') this.renderSaved();
    if (view === 'steps') this.renderSteps();
    if (update) { const url = new URL(location.href); url.searchParams.set('screen', view); url.searchParams.set('level', this.level); history.pushState({}, '', url); this.scrollTop(); }
  }
  scrollTop() { this.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'}); }
  focusSummary() { const s = this.q('[data-summary]'); s.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'}); s.focus({preventScroll:true}); }
  changed(name) {
    this.dirty = true;
    if (name === 'family') {
      this.field('rate').value = this.group(this.field('family').value).rate;
      this.choices.wax = ''; this.choices.dye = '';
      const gel = this.field('family').value === 'gel';
      this.q('[data-gel-note]').hidden = !gel; this.q('[data-dye-control]').hidden = gel;
      if (gel) this.field('dye').value = '';
      this.syncFragrances();
      this.q('.fst-scene-title').textContent = this.group(this.field('family').value).title + ' · ' + this.t('plan_label');
    }
    if (name === 'fragrance') { this.choices.fragrance = ''; this.field('density').value = ''; const p = this.products.find(p => String(p.id) === this.field('fragrance').value); if (p?.meta?.density_verified === true && Number(p.meta.density_g_ml) > 0) this.field('density').value = p.meta.density_g_ml; }
    if (name === 'dye') this.choices.dye = '';
    this.calculate();
  }
  candidates(kind) {
    let products = kind === 'wax' ? this.group(this.field('family').value).products : this.group(kind).products;
    if (kind === 'fragrance' && this.field('family').value === 'gel') products = this.group('gel_fragrance').products;
    if (['fragrance','dye'].includes(kind)) products = products.filter(p => String(p.id) === this.field(kind).value);
    const unit = {wax:'g',fragrance:'ml',dye:'cc',wick:'m',container:'adet',equipment:'adet'}[kind];
    return products.flatMap(p => p.variants.map(v => ({...v, product:p, size:FabrikoneStudio.size(p,v,unit)})));
  }
  syncFragrances() {
    const select=this.field('fragrance'), previous=select.value;
    const group=this.group(this.field('family').value==='gel'?'gel_fragrance':'fragrance');
    select.replaceChildren(new Option(this.t('unscented'),''));
    group.products.forEach(p=>select.add(new Option(this.shortTitle(p.title),String(p.id))));
    select.value=group.products.some(p=>String(p.id)===previous)?previous:'';
    if(select.value!==previous){delete this.choices.fragrance;this.field('density').value='';}
  }
  calculate() {
    this.q('[data-validation]').textContent = '';
    this.q('[data-cart-status]').textContent = '';
    if (!this.form.checkValidity()) { this.valid = false; this.q('[data-add]').disabled = true; this.q('[data-validation]').textContent = this.t('invalid'); return; }
    try { this.result = FabrikoneStudio.quantities(this.inputs()); } catch { this.valid = false; this.q('[data-add]').disabled = true; this.q('[data-validation]').textContent = this.t('invalid'); return; }
    this.valid = true; const r = this.result;
    this.q('[data-metrics]').replaceChildren(...[[this.t('wax'), r.wax, 'g'], [this.t('fragrance'), r.fragrance, 'g'], [this.t('dye_estimate'), r.dye, 'cc'], [this.t('wick_cut'), r.cut, 'cm']].map(([label,value,unit]) => { const box = this.el('div'); box.append(this.el('small',label),this.el('strong',this.fmt(value)+' '+unit)); return box; }));
    this.rows = ['wax','fragrance','dye','wick','container'].filter(k => !['fragrance','dye'].includes(k) || r.need[k] > 0).map(kind => {
      const candidates = this.candidates(kind), unit = {wax:'g',fragrance:'ml',dye:'cc',wick:'m',container:'adet'}[kind];
      const need = kind === 'fragrance' ? r.fragranceMl : r.remaining[kind];
      const selected = this.choices[kind];
      const plan = kind === 'container' && !selected ? null : FabrikoneStudio.packagePlan(candidates, need, selected);
      return {kind, unit, need, total:kind === 'fragrance' ? r.fragrance : r.need[kind], plan, candidates};
    });
    this.renderMaterials(); this.renderTools(); this.renderTotal();
    this.q('[data-color-note]').hidden = !r.dye;
    this.q('[data-color-trial]').textContent = this.t('color_trial') + ': ' + this.fmt(r.dyeTrial) + ' g · ' + this.t('tone_note');
    this.dirty = true;
  }
  renderMaterials() {
    this.q('[data-materials]').replaceChildren(...this.rows.map(row => {
      const {kind,plan} = row, card = this.el('article',null,'fst-material'), head = this.el('div',null,'fst-material-head');
      const p = plan?.variant.product || row.candidates[0]?.product;
      if (p?.image) { const img = this.el('img'); img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.width = 58; img.height = 58; head.append(img); }
      const info = this.el('div'), label = this.t(kind); info.append(this.el('h3',label),this.el('p',this.t('need')+': '+this.fmt(row.total)+' '+(kind === 'fragrance' ? 'g' : row.unit))); head.append(info);
      const body = this.el('div',null,'fst-material-body');
      if (!row.need) body.append(this.el('strong',this.t('covered')));
      else if (plan) {
        body.append(this.el('strong',plan.quantity+' × '+this.shortTitle(plan.variant.product.title)+' · '+(plan.variant.title === 'Default Title' ? this.fmt(plan.variant.size)+' '+row.unit : plan.variant.title)));
        body.append(this.el('small',this.t(kind === 'fragrance' ? 'approx_left' : 'left')+': '+this.fmt(plan.left)+' '+row.unit+' · '+this.price(plan.cost)));
      } else body.append(this.el('p',this.t(kind === 'container' && !this.choices.container ? 'container_unmatched' : 'no_package'),'fst-missing'));
      if (kind === 'fragrance') body.append(this.el('small',this.t('scent_conversion')+' '+this.fmt(this.result.fragranceMl)+' ml. '+this.t('scent_tare')));
      if (kind === 'dye') body.append(this.el('small','1 cc / 100 g wax · '+this.t('shopping_estimate')));
      if (kind === 'wick') body.append(this.el('small',this.fmt(this.result.count)+' × '+this.fmt(this.result.cut)+' cm · '+this.t('wick_note')));
      const owned = this.el('label',null,'fst-own'), check = this.el('input'); check.type = 'checkbox'; check.checked = !!this.owned[kind]; check.addEventListener('change',()=>{this.owned[kind]=check.checked;this.calculate();},{signal:this.life.signal}); owned.append(check,document.createTextNode(this.t('owned_all'))); body.append(owned);
      const b = this.button(this.t(kind === 'container' ? 'choose_container' : 'change_package'),()=>this.openMaterial(kind,b)); body.append(b); card.append(head,body); return card;
    }));
  }
  renderTools() {
    this.tools = this.group('equipment').products.flatMap(p => p.variants.filter(v => v.available).slice(0,1).map(v => ({...v,product:p,size:1})));
    this.q('[data-tools]').replaceChildren(...this.tools.map(v => { const label=this.el('label'), check=this.el('input');check.type='checkbox';check.checked=!this.toolOwned[v.id];check.addEventListener('change',()=>{this.toolOwned[v.id]=!check.checked;this.renderTotal();this.dirty=true;},{signal:this.life.signal});label.append(check,document.createTextNode(this.shortTitle(v.product.title)+' · '+this.price(v.price)));return label;}));
  }
  renderTotal() {
    this.cartItems = this.rows.filter(r => r.plan && r.need > 0).map(r => ({id:r.plan.variant.id,quantity:r.plan.quantity,price:r.plan.cost}));
    for(const v of this.tools||[]) if(!this.toolOwned[v.id]) { const p=FabrikoneStudio.packagePlan([v],1);if(p)this.cartItems.push({id:v.id,quantity:p.quantity,price:p.cost}); }
    this.total = this.cartItems.reduce((sum,i)=>sum+i.price,0);
    this.q('[data-total]').textContent = this.price(this.total);
    const extra = ['packaging','labor','other'].reduce((s,n)=>s+Math.max(0,Number(this.field(n).value)||0),0);
    this.q('[data-unit-cost]').textContent = this.t('cash_per_candle')+': '+this.price((this.total+extra*100)/this.result.count);
    const pending = this.rows.filter(r=>r.need>0&&!r.plan).map(r=>this.t(r.kind));
    this.q('[data-pending]').textContent = pending.length ? this.t('pending')+': '+pending.join(', ')+'. '+this.t('partial_cart') : this.t('package_method');
    this.q('[data-add]').disabled = this.busy || !this.valid || !this.cartItems.length;
  }
  openMaterial(kind,trigger) {
    this.returnFocus = trigger; this.activeKind = kind;
    const row = this.rows?.find(r=>r.kind===kind); this.q('[data-dialog-title]').textContent = this.t(kind);
    this.q('[data-dialog-need]').textContent = row ? this.t('need')+': '+this.fmt(row.need)+' '+row.unit : this.t(kind==='fragrance'?'choose_scent_first':'choose_color_first');
    const body=this.q('[data-dialog-content]');body.replaceChildren();
    if(!row){body.append(this.button(this.t('back_to_choices'),()=>{this.dialog.close();this.field(kind)?.focus();}));}
    else {
      body.append(this.button(this.t('automatic_package'),()=>{delete this.choices[kind];this.calculate();this.dialog.close();}));
      const products = [...new Map(row.candidates.map(v=>[v.product.id,v.product])).values()];
      for(const p of products){
        const card=this.el('article',null,'fst-choice'), info=this.el('div');
        if(p.image){const img=this.el('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=70;img.height=70;card.append(img);}
        info.append(this.el('h3',this.shortTitle(p.title)));
        const opts=row.candidates.filter(v=>v.product.id===p.id), select=this.el('select');select.setAttribute('aria-label',p.title+' · '+this.t('package'));
        opts.forEach(v=>{const o=new Option((v.title==='Default Title'?this.fmt(v.size)+' '+row.unit:v.title)+' · '+this.price(v.price),String(v.id));o.disabled=!v.available||!v.size;select.add(o);});
        const initial=opts.find(v=>String(v.id)===String(this.choices[kind]))||opts.find(v=>v.available&&v.size);if(initial)select.value=String(initial.id);info.append(select);
        const note=this.el('small'),apply=this.button(this.t('apply_project'),()=>{const v=opts.find(v=>String(v.id)===select.value);if(!v)return;this.choices[kind]=v.id;this.owned[kind]=false;this.calculate();this.dialog.close();},'fst-primary');
        const update=()=>{const v=opts.find(v=>String(v.id)===select.value), plan=v&&FabrikoneStudio.packagePlan([v],row.need||row.total);apply.disabled=!plan;note.textContent=plan?plan.quantity+' '+this.t('packages')+' · '+this.price(plan.cost)+' · '+this.t('left')+' '+this.fmt(plan.left)+' '+row.unit:this.t('no_package');};select.addEventListener('change',update,{signal:this.life.signal});update();info.append(note,apply);
        const link=this.el('a',this.t('product_details')+' ↗');link.href=p.url;link.target='_blank';link.rel='noopener';info.append(link);
        if(p.pdf&&/\.pdf(?:\?|$)/i.test(p.pdf)){const pdf=this.el('a',this.t('pdf')+' ↓');pdf.href=p.pdf;pdf.target='_blank';pdf.rel='noopener';info.append(pdf);}
        card.append(info);body.append(card);
      }
      if(kind==='container')body.prepend(this.el('p',this.t('container_note'),'fst-hint'));
      if(!products.length)body.append(this.el('p',this.t('no_package')));
    }
    this.oldOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';
  }
  async addToCart(){
    if(this.busy||!this.valid||!this.cartItems?.length)return;
    this.busy=true;this.q('[data-add]').disabled=true;const status=this.q('[data-cart-status]');status.textContent=this.t('adding');
    const quantities=new Map();this.cartItems.forEach(i=>quantities.set(i.id,(quantities.get(i.id)||0)+i.quantity));
    const controller=new AbortController();this.cartController=controller;const timeout=setTimeout(()=>controller.abort(),20000);
    try{const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:controller.signal,body:JSON.stringify({items:[...quantities].map(([id,quantity])=>({id,quantity}))})});const data=await response.json();if(!response.ok)throw new Error(data.description||this.t('cart_error'));status.textContent=this.t('added');const a=this.el('a',this.t('cart')+' →');a.href=this.dataset.root+'cart';status.append(document.createTextNode(' '),a);document.dispatchEvent(new CustomEvent('cart:refresh'));document.dispatchEvent(new CustomEvent('cart:updated'));this.lastAdded=true;}
    catch(e){status.textContent=e.name==='AbortError'?this.t('cart_uncertain'):e.message||this.t('cart_error');}
    finally{clearTimeout(timeout);this.busy=false;this.renderTotal();}
  }
  record(){return {version:1,id:this.projectId||('p-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8)),updated:new Date().toISOString(),level:this.level,values:Object.fromEntries(new FormData(this.form)),owned:{...this.owned},choices:{...this.choices},toolOwned:{...this.toolOwned},checks:[...this.checks],notes:this.q('[data-notes]').value.slice(0,4000)};}
  validateRecord(raw){
    if(!raw||raw.version!==1||!raw.values||typeof raw.values!=='object')throw new Error(this.t('import_error'));
    const values={};for(const input of this.form.elements)if(input.name&&Object.hasOwn(raw.values,input.name))values[input.name]=String(raw.values[input.name]).slice(0,input.name==='name'?80:input.name==='batch'?60:100);
    if(!this.catalog.some(g=>g.kind==='family'&&g.key===values.family))throw new Error(this.t('import_error'));
    const counts=FabrikoneStudio.quantities({...values,owned:{}});if(!counts)throw new Error(this.t('import_error'));
    for(const name of ['packaging','labor','other'])if(values[name]!==undefined&&(!Number.isFinite(Number(values[name]))||Number(values[name])<0||Number(values[name])>1000000))throw new Error(this.t('import_error'));
    const known=new Set(this.products.flatMap(p=>p.variants.map(v=>String(v.id))));
    const choices={};for(const kind of ['wax','fragrance','dye','wick','container'])if(known.has(String(raw.choices?.[kind])))choices[kind]=Number(raw.choices[kind]);
    const owned={};for(const kind of ['wax','fragrance','dye','wick','container'])owned[kind]=raw.owned?.[kind]===true;
    const toolOwned={};for(const v of this.group('equipment').products.flatMap(p=>p.variants))toolOwned[v.id]=raw.toolOwned?.[v.id]===true;
    return {version:1,id:typeof raw.id==='string'&&/^p-[a-z0-9-]{1,70}$/.test(raw.id)?raw.id:'p-'+Date.now().toString(36),updated:!Number.isNaN(Date.parse(raw.updated))?raw.updated:new Date().toISOString(),values,owned,choices,toolOwned,checks:Array.from({length:5},(_,i)=>raw.checks?.[i]===true),notes:typeof raw.notes==='string'?raw.notes.slice(0,4000):'',level:['beginner','maker','workshop'].includes(raw.level)?raw.level:'beginner'};
  }
  readSaved(){try{const raw=localStorage.getItem(this.storageKey);if(!raw)return [];if(raw.length>1000000)throw new Error();const parsed=JSON.parse(raw);if(!Array.isArray(parsed))throw new Error();return parsed.slice(0,50).map(p=>this.validateRecord(p));}catch{this.q('[data-status]').textContent=this.t('storage_read_error');return null;}}
  async refreshAccount(){
    await this.cloud.refresh(); if(!this.life || this.life.signal.aborted)return;
    if(this.projectOwner && ['guest','account'].includes(this.cloud.mode) && this.projectOwner!==this.cloud.customerId){
      this.dirty=false;this.newProject(true);this.q('[data-status]').textContent=this.t('account_changed');
    }
    this.renderAccount();if(this.screen==='saved')this.renderSaved();
  }
  renderAccount(){
    const mode=this.cloud.mode;
    this.q('[data-account-message]').textContent=this.t('cloud_'+mode);
    this.q('[data-cloud-login]').hidden=mode==='account';
    this.querySelectorAll('[data-save]').forEach(b=>{b.textContent=this.t(this.saving?'cloud_saving':mode==='account'?'cloud_save':mode==='guest'?'device_save':'save');b.disabled=!!this.saving||mode==='checking';});
    this.q('[data-account-refresh]').disabled=!!this.saving;
    this.q('[data-copy-project]').hidden=!this.conflict;
  }
  async save(){
    if(this.saving)return;
    if(!this.form.reportValidity()||!this.valid){this.show('plan');this.q('[data-status]').textContent=this.t('invalid');return;}
    const previousOwner=this.projectOwner;
    this.saving=true;this.renderAccount();
    this.q('[data-status]').textContent=this.t('cloud_saving');
    try{
      await this.refreshAccount();
      if(previousOwner&&previousOwner!==this.cloud.customerId)throw new Error('ACCOUNT_CHANGED');
      if(this.cloud.mode==='guest'&&!previousOwner){this.saveDevice();return;}
      if(this.cloud.mode!=='account')throw new Error('CONNECTION_FAILED');
      const record=this.record();this.projectId=record.id;
      // Retain the exact revision originally opened, even after a refresh from another device.
      const owner=this.cloud.customerId, before=JSON.stringify({...record,updated:''});
      const saved=await this.cloud.save(record,this.projectRevision||0,owner);
      this.projectOwner=owner;this.projectRevision=saved.revision;this.conflict=false;
      this.dirty=JSON.stringify({...this.record(),updated:''})!==before;
      this.q('[data-status]').textContent=this.t('cloud_saved');
      if(this.screen==='saved')this.renderSaved();
    }catch(error){
      this.conflict=error.status===409;
      this.q('[data-status]').textContent=this.t(error.status===409?'cloud_conflict':error.message==='ACCOUNT_CHANGED'?'account_changed':error.message==='ACCOUNT_STORAGE_FULL'?'cloud_full':'cloud_failed');
      if(error.status===401 || error.status===403)await this.refreshAccount();
    }finally{this.saving=false;this.renderAccount();}
  }
  saveDevice(){
    // Account projects are never copied into shared guest browser storage.
    if(this.projectOwner)return;
    const record=this.record(), saved=this.readSaved();if(!saved)return;
    const next=saved.filter(p=>p.id!==record.id);if(next.length>=50){this.q('[data-status]').textContent=this.t('storage_full');return;}
    next.unshift(record);
    try{localStorage.setItem(this.storageKey,JSON.stringify(next));this.projectId=record.id;this.dirty=false;this.q('[data-status]').textContent=this.t('saved_success');}
    catch{this.q('[data-status]').textContent=this.t('storage_error');}
  }
  loadRecord(record,owner='',revision=0){
    if(this.saving)return;
    this.projectOwner=owner;this.projectRevision=revision;this.conflict=false;
    this.form.reset();for(const [name,value] of Object.entries(record.values)){const f=this.field(name);if(f)f.value=value;}
    this.projectId=record.id;this.owned=record.owned;this.choices=record.choices;this.toolOwned=record.toolOwned;this.checks=record.checks;this.q('[data-notes]').value=record.notes;this.setLevel(record.level);
    const gel=this.field('family').value==='gel';this.q('[data-gel-note]').hidden=!gel;this.q('[data-dye-control]').hidden=gel;if(gel)this.field('dye').value='';
    this.syncFragrances();
    this.calculate();this.dirty=false;this.show('plan');this.q('[data-status]').textContent=this.t('loaded');
    this.renderAccount();
  }
  renderSaved(){
    const local=this.readSaved(),box=this.q('[data-saved]');box.replaceChildren();
    const list=[];
    if(this.cloud?.mode==='account')try{for(const raw of this.cloud.projects)list.push({...this.validateRecord(raw),owner:this.cloud.customerId,revision:raw.revision});}catch{this.q('[data-status]').textContent=this.t('cloud_failed');return;}
    // Legacy device records require an explicit selection and Save to account. Never bulk-upload them.
    for(const p of local||[])list.push({...p,owner:'',revision:0});
    if(!list.length){const empty=this.el('div',null,'fst-empty');empty.append(this.el('strong',this.t('empty_title')),this.el('p',this.t('empty_text')),this.button(this.t('new_project')+' →',()=>this.newProject(),'fst-primary'));box.append(empty);return;}
    for(const p of list){const card=this.el('article',null,'fst-saved-card');card.append(this.el('span',this.t(p.owner?'cloud_badge':'device_badge')+' · '+this.t(p.level),'fst-eyebrow'),this.el('h3',p.values.name||this.t('new_project')),this.el('p',p.values.count+' '+this.t('candles')+' · '+this.fmt(Number(p.values.count)*Number(p.values.fill))+' g wax'),this.el('p',this.t('saved_on')+' '+new Date(p.updated).toLocaleDateString(this.dataset.locale||'tr-TR')),this.button(this.t(!p.owner&&this.cloud?.mode==='account'?'device_open':'continue'),async()=>{
      if(this.saving || (this.dirty&&!confirm(this.t('unsaved_confirm'))))return;
      let selected=p;
      if(p.owner){await this.refreshAccount();if(this.cloud.mode!=='account'||this.cloud.customerId!==p.owner)return;const current=this.cloud.projects.find(item=>item.id===p.id);if(!current)return;try{selected={...this.validateRecord(current),revision:current.revision};}catch{return;}}
      this.loadRecord(selected,p.owner,selected.revision);if(!p.owner&&this.cloud.mode==='account'){this.projectId=null;this.q('[data-status]').textContent=this.t('device_transfer_note');}
    },'fst-primary'));
    if(p.owner)card.append(this.button(this.t('delete_project'),()=>this.deleteProject(p)));
    box.append(card);}
  }
  async deleteProject(p){
    if(this.saving||!confirm(this.t('delete_confirm')))return;
    this.saving=true;this.renderAccount();
    try{await this.refreshAccount();await this.cloud.remove(p.id,p.revision,p.owner);if(this.projectId===p.id){this.projectId=null;this.projectRevision=0;this.dirty=true;}this.q('[data-status]').textContent=this.t('deleted');this.renderSaved();}
    catch{this.q('[data-status]').textContent=this.t('delete_failed');}
    finally{this.saving=false;this.renderAccount();}
  }
  newProject(force=false){
    if(this.saving&&!force)return;
    if(this.dirty&&!confirm(this.t('unsaved_confirm')))return;
    this.projectOwner='';this.projectRevision=0;this.conflict=false;
    this.form.reset();this.field('family').value='leaf';this.field('fragrance').value='';this.field('dye').value='';this.projectId=null;this.owned={};this.choices={};this.toolOwned={};this.checks=[];this.q('[data-notes]').value='';this.setLevel('beginner');this.changed('family');this.dirty=false;this.show('plan');this.q('[data-status]').textContent='';
  }
  exportRecord(){
    if(!this.valid){this.q('[data-status]').textContent=this.t('invalid');return;}
    const blob=new Blob([JSON.stringify(this.record(),null,2)],{type:'application/json'}),url=URL.createObjectURL(blob),a=this.el('a');a.href=url;a.download='fabrikone-projem-'+new Date().toISOString().slice(0,10)+'.json';document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
  }
  async importFile(input){
    if(this.saving){input.value='';return;}
    const file=input.files?.[0];if(!file)return;
    try{if(file.size>1000000)throw new Error(this.t('import_error'));const record=this.validateRecord(JSON.parse(await file.text()));if(this.dirty&&!confirm(this.t('unsaved_confirm')))return;this.loadRecord(record);this.projectId=null;this.dirty=true;this.q('[data-status]').textContent=this.t('import_success');}
    catch{this.q('[data-status]').textContent=this.t('import_error');}finally{input.value='';}
  }
  renderSteps(){
    const r=this.result;if(!r)return;const family=this.field('family').value;
    const steps=[['step_prepare',this.t('step_prepare_text')],['step_wick',this.t('step_wick_text')+' '+this.fmt(r.cut)+' cm × '+this.fmt(r.count)+'. '+this.t('wick_note')],['step_heat',this.t(family==='leaf'?'step_soy_heat':'step_heat_text')],['step_mix',this.t('step_mix_text')+' '+this.fmt(r.fragrance)+' g. '+(r.dye?this.t('dye_note'):'')],['step_rest',this.t(family==='leaf'?'step_soy_rest':'step_rest_text')]];
    this.q('[data-steps]').replaceChildren(...steps.map(([key,text],i)=>{const card=this.el('article',null,'fst-step'),info=this.el('div');card.append(this.el('span',i+1));info.append(this.el('h3',this.t(key)),this.el('p',text));const label=this.el('label'),check=this.el('input');check.type='checkbox';check.checked=!!this.checks[i];check.addEventListener('change',()=>{this.checks[i]=check.checked;this.dirty=true;},{signal:this.life.signal});label.append(check,document.createTextNode(this.t('completed')));info.append(label);card.append(info);return card;}));
  }
  click(e){
    const b=e.target.closest('button');if(!b||!this.contains(b)||b.disabled)return;
    if(b.hasAttribute('data-level')){this.setLevel(b.dataset.level);this.dirty=true;}
    if(b.hasAttribute('data-view'))this.show(b.dataset.view);
    if(b.hasAttribute('data-material'))this.openMaterial(b.dataset.material,b);
    if(b.hasAttribute('data-close'))this.dialog.close();
    if(b.hasAttribute('data-save'))this.save();
    if(b.hasAttribute('data-account-refresh'))this.refreshAccount();
    if(b.hasAttribute('data-copy-project')){this.projectId=null;this.projectRevision=0;this.conflict=false;this.dirty=true;this.renderAccount();this.save();}
    if(b.hasAttribute('data-new'))this.newProject();
    if(b.hasAttribute('data-export'))this.exportRecord();
    if(b.hasAttribute('data-add'))this.addToCart();
  }
  disconnectedCallback(){this.life?.abort();this.life=null;this.cartController?.abort();if(this.dialog?.open)document.documentElement.style.overflow=this.oldOverflow||'';}
}
if(!customElements.get('fab-studio'))customElements.define('fab-studio',FabrikoneStudio);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
